import React from 'react';
import { Container, Typography, Button, Box, Avatar, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSuperadminAuth } from '../contexts/SuperadminAuthContext';
import { SUPERADMIN_ROUTES } from '../routes/routes';
import { LogoutOutlined, Person } from '@mui/icons-material';

const SuperadminDashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useSuperadminAuth();

  const handleLogout = async () => {
    await logout();
    navigate(SUPERADMIN_ROUTES.LOGIN);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Superadmin Dashboard
          </Typography>
          {user && (
            <Stack direction="row" spacing={2} alignItems="center">
              <Avatar sx={{ width: 40, height: 40 }}>
                {user.avatar ? (
                  <img
                    src={user.avatar}
                    alt={user.name}
                    style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                  />
                ) : (
                  <Person />
                )}
              </Avatar>
              <Box>
                <Typography variant="subtitle1" fontWeight="medium">
                  Welcome back, {user.name}!
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {user.email} • {user.role}
                </Typography>
              </Box>
            </Stack>
          )}
        </Box>

        <Button
          variant="outlined"
          onClick={handleLogout}
          startIcon={<LogoutOutlined />}
          sx={{ textTransform: 'none' }}
        >
          Logout
        </Button>
      </Box>
    </Container>
  );
};

export default SuperadminDashboardPage;
